import { sortOptionService } from './sortOptionService.js';

angular.module('signalview.chartSorter', []).service('sortOptionService', sortOptionService);
